import { take } from 'rxjs/operators';

import { AppConfigService } from './app-config.service';

/**
 * this factory is used on the app loading to get all features
 * @param appConfigService instance AppConfigService
 */
export function appConfigFactory(appConfigService: AppConfigService) {
  return (): Promise<any> => {
    return appConfigService.load().pipe(take(1)).toPromise();
  };
}
